import { connect } from "react-redux";
import { setCptyData } from "../actions";

const mapDispatchToProps = (dispatch) => ({
  set_CptyData: (data) => {
    dispatch(setCptyData(data));
  },
});

const mapStateToProps = (state) => ({
  cptyData: state.cptyData,
});

export default connect(mapStateToProps, mapDispatchToProps);
